import { FormHelperText as MuiFormHelperText, FormHelperTextProps } from '@mui/material';
import { Tooltip } from '@components/tooltip/Tooltip';
export const FormHelperText = ({ ...other }: FormHelperTextProps) => {
  const noTooltip = other.children === ' ' || (typeof other.children === 'string' && other.children.length < 70);

  return noTooltip ? (
    <MuiFormHelperText
      {...other}
      sx={{
        marginBottom: '8px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&.MuiFormHelperText-root': {
          color: 'text.caption',
          '&.Mui-error': {
            color: 'error.main',
          },
          '&.Mui-disabled': {
            color: 'text.disabled',
          },
        },
      }}
    />
  ) : (
    <Tooltip title={other.children}>
      <MuiFormHelperText
        {...other}
        sx={{
          marginBottom: '8px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          '&.MuiFormHelperText-root': {
            color: 'text.caption',
            '&.Mui-error': {
              color: 'error.main',
            },
            '&.Mui-disabled': {
              color: 'text.disabled',
            },
          },
        }}
      />
    </Tooltip>
  );
};
